import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLenis } from "@/lib/lenis";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Numbers from "@/components/sections/Numbers";
import Proposals from "@/components/sections/Proposals";
import Ecosystem from "@/components/sections/Ecosystem";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import LegalNotes from "@/pages/LegalNotes";

function Landing() {
  useLenis();
  useEffect(() => {
    document.title = "Modo Motori — Media Kit del canale YouTube automotive";
    const desc = "Modo Motori è il canale editoriale automotive del gruppo Delta Pictures. Format originali e video su misura per raccontare il mondo dei motori e dare visibilità ai brand.";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement("meta"); meta.setAttribute("name", "description"); document.head.appendChild(meta); }
    meta.setAttribute("content", desc);
    // Open Graph for email/social share
    const setMeta = (prop, content) => {
      let m = document.querySelector(`meta[property="${prop}"]`);
      if (!m) { m = document.createElement("meta"); m.setAttribute("property", prop); document.head.appendChild(m); }
      m.setAttribute("content", content);
    };
    setMeta("og:title", "Modo Motori — Format editoriali per l'automotive");
    setMeta("og:description", desc);
    setMeta("og:type", "website");
  }, []);
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Numbers />
        <Proposals />
        <Ecosystem />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cookie" element={<CookiePolicy />} />
        <Route path="/note-legali" element={<LegalNotes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
